import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import localFont from 'next/font/local'
import { Hanken_Grotesk, IBM_Plex_Mono } from 'next/font/google'

const heading = localFont({
    src: '../fonts/bonk-vf.ttf',
    weight: '100 900',
    display: 'swap',
    fallback: ['ui-sans-serif', 'system-ui', 'sans-serif']
})

const sans = Hanken_Grotesk({
    subsets: ['latin'],
    display: 'swap'
})

const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
